import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Chương trình ưu đãi", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-2" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_17 = { class: "filter-slim d-flex align-items-center gap-3 ms-3 my-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_19 = { class: "card-toolbar" }
const _hoisted_20 = {
  class: "justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = { class: "svg-icon svg-icon-2" }
const _hoisted_23 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_combination",
  "data-bs-target": "#kt_modal_add_combination"
}
const _hoisted_24 = { class: "card-body umt-form pt-0" }
const _hoisted_25 = { class: "text-muted fs-8 mt-1" }
const _hoisted_26 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_27 = {
  key: 0,
  class: "badge badge-light-warning fs-9",
  title: "TVV phải tự chọn, hệ thống không tự áp"
}
const _hoisted_28 = {
  key: 1,
  class: "badge badge-light-primary fs-9",
  title: "Bỏ qua thời gian áp dụng + điều kiện kích hoạt — chỉ cần Kích hoạt là luôn hiện ra để chọn"
}
const _hoisted_29 = {
  key: 2,
  class: "badge badge-light-info fs-9",
  title: "Cổng sinh viên không tự chọn được, chỉ xem khi tư vấn viên đã cấp"
}
const _hoisted_30 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "badge badge-light fs-8" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = {
  key: 0,
  class: "bi bi-x-circle fs-4 text-gray-400",
  title: "Đang tắt — ưu đãi không hiện ra để chọn"
}
const _hoisted_35 = {
  key: 1,
  class: "bi bi-check-circle-fill fs-4 text-success",
  title: "Đang kích hoạt"
}
const _hoisted_36 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_38 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-9 fst-italic" }, "không áp hạn", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-light-danger fs-9",
  title: "Đã quá ngày kết thúc — hệ thống KHÔNG tự chặn, cần tắt Kích hoạt nếu không dùng nữa"
}, "Hết hạn", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_45 = ["title"]
const _hoisted_46 = {
  key: 1,
  class: "badge badge-light-primary fs-9",
  title: "Giảm thêm theo số học kỳ đóng trước"
}
const _hoisted_47 = {
  key: 2,
  class: "badge badge-light-info fs-9",
  title: "Chỉ áp dụng khi thỏa điều kiện kích hoạt"
}
const _hoisted_48 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_49 = { class: "wrap-line-3 mw-300px text-muted" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "d-flex flex-center gap-5" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".7"}
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  class: "svg-icon svg-icon-2 svg-icon-danger",
  style: {"opacity":".6"}
}
const _hoisted_56 = {
  class: "modal fade umt-form",
  id: "kt_modal_add_combination",
  ref: "addCombinationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_60 = { class: "fw-bolder d-flex align-items-center gap-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-icon btn-sm btn-light-primary w-25px h-25px",
  title: "Hướng dẫn điền"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle fs-7" })
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "umt-guide fs-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-3" }, "Cách điền một chương trình ưu đãi"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fs-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "1. Thông tin"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Tên và mã để nhận diện. "),
      /*#__PURE__*/_createElementVNode("b", null, "Ưu tiên"),
      /*#__PURE__*/_createTextVNode(": số nhỏ được xét trước khi nhiều ưu đãi cùng thỏa. "),
      /*#__PURE__*/_createElementVNode("b", null, "Chọn tay"),
      /*#__PURE__*/_createTextVNode(": TVV phải tự chọn, hệ thống không tự áp.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "2. Chi tiết ưu đãi"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Phần quyết định số tiền. Bỏ trống thì ưu đãi không giảm gì. Bật "),
      /*#__PURE__*/_createElementVNode("b", null, "Multibuy"),
      /*#__PURE__*/_createTextVNode(" khi mức giảm thay đổi theo số học kỳ đóng trước.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "3. Điều kiện kích hoạt"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Chỉ được hưởng khi thỏa, ví dụ đóng phí giữ suất trước hạn.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "4. Ưu đãi đóng phí sớm"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Chỉ nhân viên cấp được ở hồ sơ nhập học, sinh viên không tự chọn ở cổng. Điều kiện ghi ở đây chỉ để đối chiếu — hệ thống không tự kiểm.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "5. Phạm vi áp dụng"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Để trống nghĩa là áp dụng cho tất cả trường, ngành và sinh viên.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "umt-guide-row" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "6. Mô tả hiển thị"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Đoạn chữ sinh viên đọc ở cổng nhập học.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex bg-light-warning rounded p-3 mt-3" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("b", null, "Giá được chốt lúc sinh viên chọn"),
        /*#__PURE__*/_createTextVNode(", không tính lại lúc đóng tiền. Danh sách chọn mới có lọc theo khoảng ngày ở trên, nhưng hồ sơ đã chọn trước đó vẫn giữ khoản giảm cũ dù ưu đãi đã hết hạn — đây là chủ ý. Sửa mức giảm của ưu đãi đang chạy sẽ ảnh hưởng hồ sơ chưa hoàn tất.")
      ])
    ])
  ])
], -1)
const _hoisted_63 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_64 = { class: "svg-icon svg-icon-1" }
const _hoisted_65 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_66 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-4 mb-4"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-3 me-3" }, null, -1)
const _hoisted_68 = { class: "fs-8" }
const _hoisted_69 = { class: "fw-bold text-gray-900 mb-1" }
const _hoisted_70 = { class: "mb-0 ps-3 text-gray-700" }
const _hoisted_71 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_72 = {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Thông tin ưu đãi", -1)
const _hoisted_74 = { class: "ms-auto d-flex align-items-center gap-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "umt-flag-divider mx-2" }, null, -1)
const _hoisted_76 = { class: "d-flex align-items-center gap-2" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "form-label fw-bolder mb-0 text-nowrap" }, "Kích hoạt", -1)
const _hoisted_78 = { class: "row g-3 mb-3" }
const _hoisted_79 = { class: "col-12 col-md-8" }
const _hoisted_80 = { class: "row g-3" }
const _hoisted_81 = { class: "col-12" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bolder" }, "Tên ưu đãi", -1)
const _hoisted_83 = { class: "col-12 col-md-4" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bolder text-nowrap" }, "Mã ưu đãi", -1)
const _hoisted_85 = { class: "col-6 col-md-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label fw-bolder text-nowrap",
  title: "Số nhỏ hơn được xét trước"
}, "Ưu tiên", -1)
const _hoisted_87 = { class: "col-6 col-md-3" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-nowrap" }, "Giá trị tối đa", -1)
const _hoisted_89 = { class: "col-12 col-md-3" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-nowrap" }, "Chương trình", -1)
const _hoisted_91 = { class: "col-12 col-md-4" }
const _hoisted_92 = { class: "bg-light rounded p-4 h-100" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bolder" }, [
  /*#__PURE__*/_createTextVNode("Áp dụng cho "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(số học kỳ đóng)")
], -1)
const _hoisted_94 = { class: "d-flex align-items-center flex-wrap gap-2 mt-1" }
const _hoisted_95 = { class: "text-muted fs-8 fst-italic" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-8" }, "·", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-4" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bolder" }, "Thời gian áp dụng", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mt-1" }, " Ngoài khoảng ngày này sinh viên không chọn mới được; hồ sơ đã chọn trước đó vẫn giữ khoản giảm cũ. ", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_101 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_102 = {
  class: "badge badge-circle bg-primary fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-primary text-uppercase" }, "Chi tiết ưu đãi", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— các khoản thực sự được trừ khi áp ưu đãi này", -1)
const _hoisted_105 = { class: "ms-auto d-flex align-items-center gap-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "form-label fw-bolder mb-0 text-nowrap" }, "Multibuy", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic text-nowrap" }, "— giảm theo số học kỳ đóng trước", -1)
const _hoisted_108 = {
  key: 1,
  class: "border border-primary border-dashed rounded bg-light-primary p-4 mb-3"
}
const _hoisted_109 = { class: "d-flex align-items-center mb-2" }
const _hoisted_110 = { class: "fs-8 fw-bolder text-gray-600" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-7" }, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "row g-3 align-items-start" }
const _hoisted_115 = { class: "col-12" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tên khoản giảm", -1)
const _hoisted_117 = { class: "col-md-4 col-12" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Loại ưu đãi", -1)
const _hoisted_119 = { class: "col-md-4 col-6" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_121 = { class: "col-md-4 col-6" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  title: "allowMultiPromotions"
}, "Cộng dồn", -1)
const _hoisted_123 = {
  key: 0,
  class: "text-muted fs-8 fst-italic ms-2"
}
const _hoisted_124 = {
  key: 0,
  class: "text-muted fs-8 fst-italic mt-1"
}
const _hoisted_125 = {
  key: 1,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-3 mb-2"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-4 me-3" }, null, -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-900" }, "Chưa có khoản giảm nào"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700" }, [
    /*#__PURE__*/_createTextVNode("Ưu đãi vẫn lưu được nhưng sẽ "),
    /*#__PURE__*/_createElementVNode("b", null, "không trừ đồng nào"),
    /*#__PURE__*/_createTextVNode(" cho sinh viên. Bấm \"Thêm khoản giảm\" để nhập số tiền / phần trăm được giảm.")
  ])
], -1)
const _hoisted_128 = [
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_130 = {
  key: 2,
  class: "border border-primary border-dashed rounded bg-light-primary p-4 mb-3"
}
const _hoisted_131 = { class: "d-flex align-items-center mb-2" }
const _hoisted_132 = { class: "fs-8 fw-bolder text-gray-600" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-7" }, null, -1)
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = { class: "row g-3 align-items-start" }
const _hoisted_137 = { class: "col-12" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tên mức", -1)
const _hoisted_139 = { class: "col-md-4 col-12" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Min. Semester"
}, "Đóng từ (học kỳ)", -1)
const _hoisted_141 = { class: "col-md-4 col-6" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Discount type"
}, "Kiểu giảm", -1)
const _hoisted_143 = { class: "col-md-4 col-6" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Disc. % / Disc. Amount"
}, "Mức giảm", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_147 = { class: "d-flex align-items-center gap-2 pb-2 border-bottom border-gray-200 mb-3" }
const _hoisted_148 = {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer fw-bolder fs-6 text-gray-600 text-uppercase mb-0",
  for: "isCondition"
}, "Điều kiện kích hoạt", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— chỉ áp dụng ưu đãi khi thỏa điều kiện", -1)
const _hoisted_151 = {
  key: 3,
  class: "mb-3 mt-2"
}
const _hoisted_152 = { class: "row g-3" }
const _hoisted_153 = { class: "col-12 col-md-8" }
const _hoisted_154 = { class: "row g-3 align-items-start" }
const _hoisted_155 = { class: "col-md-5 col-12" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Thời gian", -1)
const _hoisted_157 = { class: "col-md-4 col-6" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Loại", -1)
const _hoisted_159 = { class: "col-md-3 col-6" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Giá trị", -1)
const _hoisted_161 = { class: "col-12" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mô tả", -1)
const _hoisted_163 = { class: "col-12 col-md-4" }
const _hoisted_164 = { class: "bg-light rounded p-3 h-100" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", {
  class: "fs-7",
  title: "isExclScholarship"
}, "Không áp dụng chung với học bổng", -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 fw-bolder text-gray-600 text-uppercase mb-2" }, "Các trường hợp áp dụng đặc biệt", -1)
const _hoisted_168 = { class: "mb-1" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Con giáo viên, nhân viên trường THPT", -1)
const _hoisted_170 = { class: "mb-1" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Con giảng viên, nhân viên UMT, Kiến Á", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Con đối tác tập đoàn Kiến Á, đối tác trường UMT", -1)
const _hoisted_173 = {
  key: 4,
  class: "separator separator-dashed my-3"
}
const _hoisted_174 = {
  key: 5,
  class: "d-flex align-items-center gap-2 pb-2 border-bottom border-gray-200 mb-3"
}
const _hoisted_175 = {
  class: "badge badge-circle bg-primary fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer fw-bolder fs-6 text-primary text-uppercase mb-0",
  for: "isAddition"
}, "Ưu đãi đóng phí sớm", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— khoản giảm CHỈ nhân viên cấp được ở hồ sơ nhập học; sinh viên không tự chọn ở cổng", -1)
const _hoisted_178 = { key: 6 }
const _hoisted_179 = { class: "d-flex align-items-center gap-2 mb-3" }
const _hoisted_180 = { class: "badge badge-circle bg-primary" }
const _hoisted_181 = { class: "fs-7 fw-bolder text-gray-700" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-6" }, null, -1)
const _hoisted_184 = [
  _hoisted_183
]
const _hoisted_185 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_186 = { class: "row g-3 w-100" }
const _hoisted_187 = { class: "col-md-4 col-12" }
const _hoisted_188 = { class: "fv-row" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tên Ưu đãi", -1)
const _hoisted_190 = { class: "col-md-4 col-12" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_192 = { class: "col-12" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mô tả", -1)
const _hoisted_194 = ["onUpdate:modelValue"]
const _hoisted_195 = { class: "col-12 bg-light rounded border-gray-300 border border-dashed p-3" }
const _hoisted_196 = { class: "d-flex align-items-center mb-2" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 fw-bolder text-gray-600 text-uppercase" }, "Điều kiện kích hoạt", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-warning fs-8 fst-italic ms-2",
  title: "Hệ thống có tính điều kiện nhưng không dùng kết quả để khoá ô chọn"
}, "— chỉ để GHI RÕ cho nhân viên tự đối chiếu, hệ thống KHÔNG tự kiểm", -1)
const _hoisted_199 = ["onClick"]
const _hoisted_200 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle text-primary me-1" }, null, -1)
const _hoisted_201 = { class: "d-flex align-items-center mb-2" }
const _hoisted_202 = { class: "fs-8 fw-bolder text-gray-600" }
const _hoisted_203 = ["onClick"]
const _hoisted_204 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-7" }, null, -1)
const _hoisted_205 = [
  _hoisted_204
]
const _hoisted_206 = { class: "row g-3 align-items-start" }
const _hoisted_207 = { class: "col-md-4 col-12" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createTextVNode("Hạn chót "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(đến hết ngày)")
], -1)
const _hoisted_209 = { class: "col-md-4 col-6" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Loại", -1)
const _hoisted_211 = { class: "col-md-4 col-6" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_213 = { class: "col-12" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mô tả", -1)
const _hoisted_215 = ["onUpdate:modelValue"]
const _hoisted_216 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_218 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_219 = {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_220 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Phạm vi áp dụng", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— để trống là áp dụng cho tất cả", -1)
const _hoisted_222 = { class: "row mb-3 p-4 bg-light rounded" }
const _hoisted_223 = { class: "col-12" }
const _hoisted_224 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 fw-bolder text-gray-600 text-uppercase mb-2" }, "Giới hạn theo nhóm đối tượng", -1)
const _hoisted_225 = { class: "col-12 col-md-4 mt-3" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tỉnh/ Thành phố", -1)
const _hoisted_227 = { class: "col-12 col-md-4 mt-3" }
const _hoisted_228 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Quận", -1)
const _hoisted_229 = { class: "col-12 col-md-4 mt-3" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Trường", -1)
const _hoisted_231 = { class: "col-12 mt-3" }
const _hoisted_232 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Các trường áp dụng", -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Các ngành áp dụng", -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Các sinh viên áp dụng", -1)
const _hoisted_235 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_236 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_237 = {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_238 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Mô tả hiển thị", -1)
const _hoisted_239 = { class: "row mb-3" }
const _hoisted_240 = { class: "col-12" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mb-2" }, "Đoạn mô tả này hiển thị cho sinh viên khi chọn ưu đãi ở cổng nhập học — viết ngắn, nêu rõ điều kiện được hưởng.", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-3" }, null, -1)
const _hoisted_243 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end gap-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }),
    /*#__PURE__*/_createTextVNode("Lưu ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/caidatthutucnhaphoc",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cài đặt thủ tục nhập học ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                class: "form-control w-250px ps-11",
                style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
                placeholder: "Tìm tên, mã ưu đãi..."
              }, null, 512), [
                [_vModelText, _ctx.search]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterActive,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterActive) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchItems())),
                "popper-class": "filter-slim-dd",
                class: "form-select-solid",
                style: {"width":"160px"},
                placeholder: "— Kích hoạt —"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Kích hoạt —",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "Đang kích hoạt",
                    value: "y"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Đang tắt",
                    value: "n"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterPriority,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterPriority) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchItems())),
                "popper-class": "filter-slim-dd",
                class: "form-select-solid",
                style: {"width":"150px"},
                placeholder: "— Ưu tiên —"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Ưu tiên —",
                    value: ""
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorityOptions(), (p) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: p,
                      label: `Ưu tiên ${p}`,
                      value: String(p)
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.filterActive || _ctx.filterPriority || _ctx.search)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light",
                    title: "Đặt lại toàn bộ bộ lọc",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.filterActive = ''; _ctx.filterPriority = ''; _ctx.search = ''; _ctx.searchItems()})
                  }, [
                    _hoisted_18,
                    _createTextVNode("Đặt lại ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "btn btn-success me-3",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportFile && _ctx.exportFile(...args)))
              }, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                ]),
                _createTextVNode(" Xuất Excel ")
              ]),
              _createElementVNode("button", {
                class: "btn btn-light-primary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.callModalAddApp && _ctx.callModalAddApp(...args)))
              }, [
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm ưu đãi ")
              ]),
              _createElementVNode("button", _hoisted_23, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            total: _ctx.tableData.length,
            currentPage: _ctx.pagination.currentPage,
            "table-header": _ctx.tableHeader,
            "rows-per-page": _ctx.pagination.limit,
            "enable-items-per-page-dropdown": true,
            loading: _ctx.loading
          }, {
            "cell-promotionName": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["fw-semibold text-gray-800", customer.isactive === false ? 'opacity-50' : ''])
                }, _toDisplayString(customer.promotionName), 3),
                _createElementVNode("div", _hoisted_25, _toDisplayString(customer.promotionCode || '—'), 1)
              ])
            ]),
            "cell-scope": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_26, [
                (customer.ismanual)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Chọn tay"))
                  : _createCommentVNode("", true),
                (customer.bypasscondition)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Bỏ qua ĐK"))
                  : _createCommentVNode("", true),
                (customer.adminonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Chỉ admin"))
                  : _createCommentVNode("", true),
                (!customer.ismanual && !customer.bypasscondition && !customer.adminonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-priority": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(customer.priority || '—'), 1)
              ])
            ]),
            "cell-isactive": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_33, [
                (customer.isactive === false)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                  : (_openBlock(), _createElementBlock("i", _hoisted_35))
              ])
            ]),
            "cell-appliedType": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedTypeList(customer.appliedType), (t) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: t,
                    class: "badge badge-light fs-9"
                  }, _toDisplayString(t), 1))
                }), 128)),
                (!_ctx.appliedTypeList(customer.appliedType).length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "—"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-startedDate": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-nowrap", customer.bypasscondition ? 'text-muted text-decoration-line-through' : ''])
                }, _toDisplayString(_ctx.formatDateVN(customer.startedDate)) + " → " + _toDisplayString(_ctx.formatDateVN(customer.endedDate)), 3),
                (customer.bypasscondition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                  : (_ctx.isExpired(customer.endedDate))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                    : _createCommentVNode("", true)
              ])
            ]),
            "cell-benefits": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_44, [
                (customer.benefit?.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "badge badge-light-success fs-9",
                      title: customer.benefit.map(b => b.name).join(', ')
                    }, " Khoản giảm (" + _toDisplayString(customer.benefit.length) + ") ", 9, _hoisted_45))
                  : _createCommentVNode("", true),
                (customer.benefitaddition?.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Multibuy (" + _toDisplayString(customer.benefitaddition.length) + ") ", 1))
                  : _createCommentVNode("", true),
                (customer.condition)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Điều kiện"))
                  : _createCommentVNode("", true),
                (!customer.benefit?.length && !customer.benefitaddition?.length && !customer.condition)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "—"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-description": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", {
                  class: "custom-table-editor",
                  innerHTML: customer.description
                }, null, 8, _hoisted_50)
              ])
            ]),
            "cell-actions": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.setDataForm(customer)),
                  class: "menu-link cursor-pointer"
                }, [
                  _createElementVNode("span", _hoisted_53, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen58.svg" })
                  ])
                ], 8, _hoisted_52),
                _createElementVNode("span", {
                  class: "menu-link cursor-pointer",
                  onClick: ($event: any) => (_ctx.deleteRow(customer))
                }, [
                  _createElementVNode("span", _hoisted_55, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/remove-file.svg" })
                  ])
                ], 8, _hoisted_54)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page", "loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("h2", _hoisted_60, [
              _createTextVNode(_toDisplayString(_ctx.isEdit ? "Chỉnh sửa ưu đãi" : "Thêm ưu đãi") + " ", 1),
              _createVNode(_component_el_popover, {
                placement: "bottom-start",
                width: 420,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _hoisted_61
                ]),
                default: _withCtx(() => [
                  _hoisted_62
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("span", _hoisted_64, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[54] || (_cache[54] = _withModifiers(($event: any) => (_ctx.submit(_ctx.formRef)), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_65, [
                  (_ctx.formWarnings().length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, "Cần rà lại " + _toDisplayString(_ctx.formWarnings().length) + " điểm trước khi lưu", 1),
                          _createElementVNode("ul", _hoisted_70, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formWarnings(), (w, i) => {
                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(w), 1))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.sectionNo('info')), 1),
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.ismanual,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.ismanual) = $event)),
                        label: "Chọn tay",
                        title: "ismanual — TVV phải tự chọn ưu đãi này, không tự áp"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.bypasscondition,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.bypasscondition) = $event)),
                        label: "Bỏ qua điều kiện",
                        title: "Bỏ qua thời gian áp dụng và điều kiện kích hoạt — chỉ cần Kích hoạt là ưu đãi luôn hiện ra để chọn"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.adminonly,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.adminonly) = $event)),
                        label: "Chỉ admin chọn",
                        title: "Chỉ tư vấn viên chọn được ở hồ sơ nhập học; cổng sinh viên không hiện để chọn (chỉ xem khi đã được cấp)"
                      }, null, 8, ["modelValue"]),
                      _hoisted_75,
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_el_switch, {
                          class: "el-switch",
                          modelValue: _ctx.formData.isactive,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.isactive) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_77
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _hoisted_82,
                          _createVNode(_component_el_form_item, { prop: "promotionName" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "form-select-solid w-100",
                                placeholder: "Tên ưu đãi",
                                modelValue: _ctx.formData.promotionName,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.promotionName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createVNode(_component_el_form_item, { prop: "promotionCode" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "form-select-solid w-100",
                                placeholder: "Mã ưu đãi",
                                modelValue: _ctx.formData.promotionCode,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.promotionCode) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _createVNode(_component_el_form_item, { prop: "priority" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "form-select-solid w-100",
                                placeholder: "1 ... 10",
                                onKeypress: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isNumber($event))),
                                modelValue: _ctx.formData.priority,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.priority) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          _hoisted_88,
                          _createVNode(_component_el_form_item, { prop: "maxvalue" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "form-select-solid w-100",
                                placeholder: "",
                                modelValue: _ctx.formData.maxvalue,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.maxvalue) = $event)),
                                onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isNumber($event))),
                                onKeyup: _cache[19] || (_cache[19] = e=> {
                                                            _ctx.formData.maxvalue = _ctx.formatCurrentMoney(_ctx.formData.maxvalue)
                                                        })
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createVNode(_component_el_form_item, { prop: "programtype" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                modelValue: _ctx.formData.programtype,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.programtype) = $event)),
                                clearable: "",
                                class: "form-select-solid w-100",
                                placeholder: "Chương trình",
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createVNode(_component_el_form_item, { prop: "appliedType" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              modelValue: _ctx.formData.appliedType,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.appliedType) = $event)),
                              "reserve-keyword": false,
                              class: "form-select-solid w-100",
                              placeholder: "Chọn số học kỳ",
                              multiple: "",
                              "collapse-tags": ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptionsSemester, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.code,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("span", _hoisted_95, "Đang chọn " + _toDisplayString((_ctx.formData.appliedType || []).length) + "/" + _toDisplayString(_ctx.typeOptionsSemester.length) + " học kỳ", 1),
                          _createElementVNode("span", {
                            class: "cursor-pointer text-primary fs-8 fw-semibold ms-auto",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectAllAppliedType()))
                          }, "Chọn tất cả"),
                          _hoisted_96,
                          _createElementVNode("span", {
                            class: "cursor-pointer text-primary fs-8 fw-semibold",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.clearAppliedType()))
                          }, "Bỏ chọn")
                        ]),
                        _hoisted_97,
                        _createElementVNode("div", null, [
                          _hoisted_98,
                          _createVNode(_component_el_form_item, { prop: "dateGroup" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "el-date-picker w-100",
                                modelValue: _ctx.formData.dateGroup,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.dateGroup) = $event)),
                                type: "daterange",
                                "range-separator": "→",
                                "start-placeholder": "Bắt đầu",
                                "end-placeholder": "Kết thúc",
                                format: "DD/MM/YYYY"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_99
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_100,
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.sectionNo('detail')), 1),
                    _hoisted_103,
                    _hoisted_104,
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_el_form_item, {
                        prop: "isregistrationfeerequest",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            onChange: _ctx.funcChangeMultiBuy,
                            modelValue: _ctx.formData.ismultibuy,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.ismultibuy) = $event))
                          }, null, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_106,
                      _hoisted_107
                    ])
                  ]),
                  (_ctx.formData.benefitaddition.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        (_ctx.formData.benefit && _ctx.formData.benefit.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.benefit, (fill, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["rounded border border-gray-200 p-3 mb-2", index % 2 ? 'bg-light' : 'bg-white']),
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("span", _hoisted_110, "Khoản giảm " + _toDisplayString(index + 1), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-light-danger ms-auto",
                                    title: "Xóa khoản giảm này",
                                    onClick: ($event: any) => (_ctx.delArrItem(fill.type))
                                  }, _hoisted_113, 8, _hoisted_111)
                                ]),
                                _createElementVNode("div", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, [
                                    _hoisted_116,
                                    _createVNode(_component_el_input, {
                                      modelValue: fill.name,
                                      "onUpdate:modelValue": ($event: any) => ((fill.name) = $event),
                                      class: "form-select-solid w-100",
                                      placeholder: "VD: Giảm học phí học kỳ 1"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_117, [
                                    _hoisted_118,
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      clearable: "",
                                      modelValue: fill.type,
                                      "onUpdate:modelValue": ($event: any) => ((fill.type) = $event),
                                      placeholder: "Chọn loại ưu đãi",
                                      class: "form-select-solid w-100",
                                      onChange: _ctx.checkItemActiveArr
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionTypeOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.code,
                                            label: item.name,
                                            value: item.code
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_119, [
                                    _hoisted_120,
                                    _createVNode(_component_el_input, {
                                      modelValue: fill.value,
                                      "onUpdate:modelValue": ($event: any) => ((fill.value) = $event),
                                      class: "form-select-solid w-100",
                                      placeholder: fill.type == 'percent' ? 'VD: 10' : 'VD: 5.000.000'
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_121, [
                                    _hoisted_122,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_checkbox, {
                                        disabled: fill.type == 'percent',
                                        modelValue: fill.allowMultiPromotions,
                                        "onUpdate:modelValue": ($event: any) => ((fill.allowMultiPromotions) = $event)
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                                      (fill.type == 'percent')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_123, "giảm theo % không cộng dồn"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (fill.allowMultiPromotions)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, " Sinh viên thấy khoản này ở cổng dưới dạng ô tick \"Ưu đãi cộng thêm\" (chọn kèm ưu đãi chính) "))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_125, _hoisted_128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addArrItem && _ctx.addArrItem(...args))),
                          class: "btn btn-sm btn-link d-flex gap-2 align-items-center text-primary"
                        }, [
                          _hoisted_129,
                          _createTextVNode(" Thêm khoản giảm ")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.benefitaddition && _ctx.formData.benefitaddition.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.benefitaddition, (fill, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["rounded border border-gray-200 p-3 mb-2", index % 2 ? 'bg-light' : 'bg-white']),
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("span", _hoisted_132, "Mức " + _toDisplayString(index + 1), 1),
                              (index != 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-light-danger ms-auto",
                                    title: "Xóa mức này",
                                    onClick: ($event: any) => (_ctx.delArrItemAddition(index))
                                  }, _hoisted_135, 8, _hoisted_133))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("div", _hoisted_137, [
                                _hoisted_138,
                                _createVNode(_component_el_input, {
                                  modelValue: fill.name,
                                  "onUpdate:modelValue": ($event: any) => ((fill.name) = $event),
                                  class: "form-select-solid w-100",
                                  placeholder: "VD: Đóng từ 4 học kỳ"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_139, [
                                _hoisted_140,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  clearable: "",
                                  modelValue: fill.semester,
                                  "onUpdate:modelValue": ($event: any) => ((fill.semester) = $event),
                                  placeholder: "Chọn số học kỳ",
                                  class: "form-select-solid w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptionsSemester, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.code,
                                        label: item.name,
                                        value: item.code
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _hoisted_142,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  clearable: "",
                                  modelValue: fill.type,
                                  "onUpdate:modelValue": ($event: any) => ((fill.type) = $event),
                                  placeholder: "Chọn kiểu giảm",
                                  class: "form-select-solid w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                                                    { code: 'percent', name: 'Theo % (percent)' },
                                                    { code: 'amount', name: 'Theo số tiền (amount)' }
                                                ], (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.code,
                                        label: item.name,
                                        value: item.code
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_143, [
                                _hoisted_144,
                                _createVNode(_component_el_input, {
                                  modelValue: fill.value,
                                  "onUpdate:modelValue": ($event: any) => ((fill.value) = $event),
                                  class: "form-select-solid w-100",
                                  placeholder: fill.type == 'percent' ? 'VD: 5' : 'VD: 5.000.000'
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ])
                            ])
                          ], 2))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.addArrItemAddition && _ctx.addArrItemAddition(...args))),
                          class: "btn btn-sm btn-link d-flex gap-2 align-items-center text-primary"
                        }, [
                          _hoisted_145,
                          _createTextVNode(" Thêm mức ưu đãi ")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_146,
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.sectionNo('condition')), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "isCondition",
                      class: "opacity-0 d-none",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.isCondition) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.isCondition]
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "isCondition",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.formData.isCondition,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.isCondition) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_149,
                    _hoisted_150
                  ]),
                  (_ctx.formData.isCondition)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("div", _hoisted_153, [
                            _createElementVNode("div", _hoisted_154, [
                              _createElementVNode("div", _hoisted_155, [
                                _hoisted_156,
                                _createVNode(_component_el_date_picker, {
                                  class: "el-date-picker w-100",
                                  modelValue: _ctx.formData.condition.date,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.condition.date) = $event)),
                                  placeholder: "Thời gian",
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_157, [
                                _hoisted_158,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  modelValue: _ctx.formData.condition.type,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.condition.type) = $event)),
                                  "reserve-keyword": false,
                                  class: "form-select-solid w-100",
                                  placeholder: "Chọn loại"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsType, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_159, [
                                _hoisted_160,
                                _createVNode(_component_el_input, {
                                  class: "form-select-solid w-100",
                                  placeholder: "Giá trị",
                                  modelValue: _ctx.formData.condition.value,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.condition.value) = $event)),
                                  onKeypress: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isNumber($event))),
                                  onKeyup: _cache[34] || (_cache[34] = e=> {
                                                        _ctx.formData.condition.value = _ctx.formatCurrentMoney(_ctx.formData.condition.value)
                                                    })
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_161, [
                                _hoisted_162,
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-textarea w-100",
                                  rows: "2",
                                  placeholder: "Mô tả",
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.condition.description) = $event))
                                }, "\n                                        ", 512), [
                                  [_vModelText, _ctx.formData.condition.description]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_163, [
                            _createElementVNode("div", _hoisted_164, [
                              _createVNode(_component_el_form_item, {
                                prop: "isExclScholarship",
                                class: "mb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox, {
                                    modelValue: _ctx.formData.condition.isExclScholarship,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.condition.isExclScholarship) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_165
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_166,
                              _hoisted_167,
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: _ctx.formData.condition.specialApplied,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.condition.specialApplied) = $event)),
                                onChange: _ctx.changeOptionSpecial
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_168, [
                                    _createVNode(_component_el_checkbox, { label: "islecturerchild" }, {
                                      default: _withCtx(() => [
                                        _hoisted_169
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_170, [
                                    _createVNode(_component_el_checkbox, { label: "isstaffchild" }, {
                                      default: _withCtx(() => [
                                        _hoisted_171
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_el_checkbox, { label: "ispartnerchild" }, {
                                      default: _withCtx(() => [
                                        _hoisted_172
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.benefitaddition && _ctx.formData.benefitaddition.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_173))
                    : _createCommentVNode("", true),
                  (_ctx.formData.benefitaddition && _ctx.formData.benefitaddition.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                        _createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.sectionNo('addition')), 1),
                        _withDirectives(_createElementVNode("input", {
                          id: "isAddition",
                          class: "opacity-0 d-none",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.isAddition) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.isAddition]
                        ]),
                        _createVNode(_component_el_form_item, {
                          prop: "isAddition",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.formData.isAddition,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.isAddition) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_176,
                        _hoisted_177
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.isAddition && _ctx.formData.benefitaddition && _ctx.formData.benefitaddition.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPromotion, (row, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "border border-primary border-dashed rounded bg-light-primary p-4 mb-3"
                          }, [
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("span", _hoisted_180, _toDisplayString(index+1), 1),
                              _createElementVNode("span", _hoisted_181, "Ưu đãi " + _toDisplayString(index+1), 1),
                              (index != 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    title: "Xóa ưu đãi này",
                                    class: "btn btn-sm btn-icon btn-light-danger ms-auto",
                                    onClick: ($event: any) => (_ctx.removeRowScholar(index))
                                  }, _hoisted_184, 8, _hoisted_182))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_185, [
                              _createElementVNode("div", _hoisted_186, [
                                _createElementVNode("div", _hoisted_187, [
                                  _createElementVNode("div", _hoisted_188, [
                                    _hoisted_189,
                                    _createVNode(_component_el_input, {
                                      class: "form-select-solid w-100",
                                      placeholder: "Tên Ưu đãi",
                                      modelValue: row.name,
                                      "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_190, [
                                  _hoisted_191,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Giá trị",
                                    modelValue: row.value,
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                                    onKeypress: _cache[40] || (_cache[40] = ($event: any) => (_ctx.isNumber($event))),
                                    onKeyup: e=> {
                                                                    row.value = _ctx.formatCurrentMoney(row.value)
                                                                }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                ]),
                                _createElementVNode("div", _hoisted_192, [
                                  _hoisted_193,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-textarea w-100",
                                    rows: "2",
                                    placeholder: "Mô tả",
                                    "onUpdate:modelValue": ($event: any) => ((row.description) = $event)
                                  }, "\n                                                    ", 8, _hoisted_194), [
                                    [_vModelText, row.description]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_195, [
                                  _createElementVNode("div", _hoisted_196, [
                                    _hoisted_197,
                                    _hoisted_198,
                                    _createElementVNode("span", {
                                      class: "cursor-pointer text-primary fs-8 fw-semibold ms-auto",
                                      onClick: ($event: any) => (_ctx.addCondition(index))
                                    }, [
                                      _hoisted_200,
                                      _createTextVNode("Thêm điều kiện ")
                                    ], 8, _hoisted_199)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.condition, (con, ind) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "bg-white rounded border border-gray-200 p-3 mb-2",
                                      key: ind
                                    }, [
                                      _createElementVNode("div", _hoisted_201, [
                                        _createElementVNode("span", _hoisted_202, _toDisplayString(ind == 0 ? 'Điều kiện 1' : 'VÀ điều kiện ' + (ind + 1)), 1),
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.removeRowCondition(index,ind)),
                                          type: "button",
                                          title: "Xóa điều kiện này",
                                          class: "btn btn-sm btn-icon btn-light-danger ms-auto"
                                        }, _hoisted_205, 8, _hoisted_203)
                                      ]),
                                      _createElementVNode("div", _hoisted_206, [
                                        _createElementVNode("div", _hoisted_207, [
                                          _hoisted_208,
                                          _createVNode(_component_el_date_picker, {
                                            class: "el-date-picker w-100",
                                            modelValue: con.date,
                                            "onUpdate:modelValue": ($event: any) => ((con.date) = $event),
                                            placeholder: "Thời gian",
                                            format: "DD/MM/YYYY"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_209, [
                                          _hoisted_210,
                                          _createVNode(_component_el_select, {
                                            "popper-class": "umt-form-dd",
                                            modelValue: con.type,
                                            "onUpdate:modelValue": ($event: any) => ((con.type) = $event),
                                            "reserve-keyword": false,
                                            class: "form-select-solid w-100",
                                            placeholder: "Chọn loại"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsType, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_211, [
                                          _hoisted_212,
                                          _createVNode(_component_el_input, {
                                            class: "form-select-solid w-100",
                                            placeholder: "Giá trị",
                                            modelValue: con.value,
                                            "onUpdate:modelValue": ($event: any) => ((con.value) = $event),
                                            onKeypress: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isNumber($event))),
                                            onKeyup: e=> {
                                                                            con.value = _ctx.formatCurrentMoney(con.value)
                                                                        }
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                        ]),
                                        _createElementVNode("div", _hoisted_213, [
                                          _hoisted_214,
                                          _withDirectives(_createElementVNode("textarea", {
                                            class: "form-textarea w-100",
                                            rows: "2",
                                            placeholder: "Mô tả",
                                            "onUpdate:modelValue": ($event: any) => ((con.description) = $event)
                                          }, "\n                                                            ", 8, _hoisted_215), [
                                            [_vModelText, con.description]
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.addNewRow && _ctx.addNewRow(...args))),
                          class: "me-auto btn btn-sm btn-link d-flex gap-2 align-items-center text-primary"
                        }, [
                          _hoisted_216,
                          _createTextVNode(" Thêm ưu đãi")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_217,
                  _createElementVNode("div", _hoisted_218, [
                    _createElementVNode("span", _hoisted_219, _toDisplayString(_ctx.sectionNo('scope')), 1),
                    _hoisted_220,
                    _hoisted_221
                  ]),
                  _createElementVNode("div", _hoisted_222, [
                    _createElementVNode("div", _hoisted_223, [
                      _hoisted_224,
                      _createVNode(_component_el_checkbox_group, {
                        onChange: _ctx.changeOption,
                        modelValue: _ctx.checkActiveSchool,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.checkActiveSchool) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_checkbox, { label: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Áp dụng cho các trường cụ thể")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_checkbox, { label: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Áp dụng cho các ngành cụ thể")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_checkbox, { label: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Áp dụng cho các sinh viên cụ thể")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onChange", "modelValue"])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["row", _ctx.checkActiveSchool.includes(0) ? '':'d-none'])
                    }, [
                      _createElementVNode("div", _hoisted_225, [
                        _hoisted_226,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          filterable: "",
                          onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.changeSelectCity($event))),
                          modelValue: _ctx.checkCity,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.checkCity) = $event)),
                          "reserve-keyword": false,
                          class: "form-select-solid w-100",
                          placeholder: "Tìm trường thuộc thành phố"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_227, [
                        _hoisted_228,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          filterable: "",
                          onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.changeSelectDistric($event))),
                          modelValue: _ctx.checkDistric,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.checkDistric) = $event)),
                          "reserve-keyword": false,
                          class: "form-select-solid w-100",
                          placeholder: "Tìm trường thuộc quận"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_229, [
                        _hoisted_230,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          filterable: "",
                          onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.changeSelectSchool($event))),
                          modelValue: _ctx.checkSchool,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.checkSchool) = $event)),
                          "reserve-keyword": false,
                          class: "form-select-solid w-100",
                          placeholder: "Chọn trường muốn thêm vào danh sách"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_231, [
                        _hoisted_232,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          multiple: "",
                          filterable: "",
                          modelValue: _ctx.formData.appliedObject[0].value,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formData.appliedObject[0].value) = $event)),
                          "reserve-keyword": false,
                          class: "form-select-solid w-100",
                          placeholder: "Để trống là áp dụng tất cả các trường"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolOptions1, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-12 mt-3", _ctx.checkActiveSchool.includes(1) ? '':'d-none'])
                    }, [
                      _hoisted_233,
                      _createVNode(_component_el_select, {
                        "popper-class": "umt-form-dd",
                        multiple: "",
                        filterable: "",
                        modelValue: _ctx.formData.appliedObject[1].value,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.formData.appliedObject[1].value) = $event)),
                        "reserve-keyword": false,
                        class: "form-select-solid w-100",
                        placeholder: "Để trống là áp dụng tất cả các ngành"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.name,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-12 mt-3", _ctx.checkActiveSchool.includes(2) ? '':'d-none'])
                    }, [
                      _hoisted_234,
                      _createVNode(_component_el_select, {
                        "popper-class": "umt-form-dd",
                        multiple: "",
                        filterable: "",
                        modelValue: _ctx.formData.appliedObject[2].value,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formData.appliedObject[2].value) = $event)),
                        "reserve-keyword": false,
                        class: "form-select-solid w-100",
                        placeholder: "Để trống là áp dụng tất cả các sinh viên"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.studentOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 2)
                  ]),
                  _hoisted_235,
                  _createElementVNode("div", _hoisted_236, [
                    _createElementVNode("span", _hoisted_237, _toDisplayString(_ctx.sectionNo('desc')), 1),
                    _hoisted_238
                  ]),
                  _createElementVNode("div", _hoisted_239, [
                    _createElementVNode("div", _hoisted_240, [
                      _hoisted_241,
                      _createVNode(_component_ckeditor, {
                        editor: _ctx.editor,
                        onReady: _ctx.onReady,
                        modelValue: _ctx.formData.description,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formData.description) = $event)),
                        config: _ctx.editorConfig
                      }, null, 8, ["editor", "onReady", "modelValue", "config"])
                    ])
                  ]),
                  _hoisted_242,
                  _hoisted_243
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}